import React from "react";
import usePageMeta from "@/hooks/usePageMeta";
import { useI18n } from "@/i18n";
import { PageHero } from "@/components/PageHero";
import Cottage from "@/components/sections/Cottage";
import Activities from "@/components/sections/Activities";
import Rules from "@/components/sections/Rules";
import Booking from "@/components/sections/Booking";

export default function Domek() {
  const { t } = useI18n();
  usePageMeta(t.meta.domek.title, t.meta.domek.desc);
  return (
    <>
      <PageHero
        image="/images/domek-hero-v2.webp"
        alt={t.pageHero.domek.alt}
        title={t.pageHero.domek.title}
        subtitle={t.pageHero.domek.subtitle}
        position="object-[50%_56%]"
        parallax={false}
        heightClass="h-[62svh] min-h-[460px] md:h-[74svh]"
      />
      <Cottage />
      <Activities />
      <Rules />
      <Booking />
    </>
  );
}
